import React, { useState } from 'react';
import { Layout, Tooltip } from 'antd';
import { CloseOutlined, DownOutlined, MenuOutlined } from '@ant-design/icons';

import { ReactComponent as Operator } from 'assets/icons/operator_icon.svg';
import { ReactComponent as EllinikiDimokratia } from 'assets/icons/logo.gov.svg';
import { ReactComponent as Ellada20Revert } from 'assets/icons/ellada_2_0.svg';

const { Header } = Layout;

const HeaderLanding = ({ setShowBot, showBot }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <Header className="app-layout__header_landing">
      <div className="header-left">
        <EllinikiDimokratia
          className="app-layout__logo-gr-democracy"
          onClick={() => window.open('https://www.gov.gr/', '_blank')}
        />
      </div>
      <div className="header-right">
        <div>
          <Ellada20Revert
            className="app-layout__logo-gr-2-0"
            onClick={() => window.open('https://greece20.gov.gr/', '_blank')}
          />
        </div>
        <div className="header-links mt-2">
          <p style={{fontWeight: 700, color: '#FFFFFF'}}>Στοιχεία Επικοινωνίας: </p>
          <div className="header-tooltip-operator">
            <Tooltip
              className="mt-3 ml-1"
              overlayClassName="custom-tooltip helpdesk-tooltip"
              placement="bottomRight"
              title={
                <div class="header-tooltip-operator-left">
                  <div class="header-tooltip-operator-left-span">
                    <div
                      style={{
                        textAlign: 'left',
                        display: 'block',
                        width: 'fit-content',
                      }}
                    >
                      <p className='helpdesk-tooltip-paragraph'>
                        Αν οι απορίες σας δεν απαντήθηκαν από τις Πληροφορίες, 
                        μπορείτε να επικοινωνήσετε με το τηλεφωνικό Κέντρο Εξυπηρέτησης της δράσης <br /> (9:00-17:00) 
                        ή να αποστείλετε email εδώ:
                      </p>
                        <ul className='helpdesk-tooltip-paragraph'>
                        <li>Για ωφελούμενους: στο 2131513753 ή στο <br /> 2131513101 και με mail στο <br />
                          <a href="mailto:allazothermansi.thermosifona@prv.ypeka.gr "
                          className="helpdesk-email">
                           allazothermansi.thermosifona@prv.ypeka.gr
                        </a> </li>
                        <li>Για προμηθευτές: στο 2131513075 ή στο <br /> 2131513355 και με mail στο <br />
                         <a
                           href="mailto:allazothermansi.thermosifona.suppliers@prv.ypeka.gr"
                          className="helpdesk-email"
                        >
                          allazothermansi.thermosifona.suppliers@prv.ypeka.gr
                       </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              }
            >
              <div className="operator">
                <Operator
                  className="operator-icon"
                  style={{ cursor: 'pointer' }}
                />
                <DownOutlined className="operator-downoutline" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="header-icon-mobile">
          {!showDropdown && (
            <MenuOutlined onClick={() => setShowDropdown(true)} />
          )}
          {showDropdown && (
            <CloseOutlined onClick={() => setShowDropdown(false)} />
          )}
        </div>
        {showDropdown && (
          <div className="header-links-mobile">
            <Operator className="operator-icon" />
            <div className="header-paragraph">
              <p>
                        Αν οι απορίες σας δεν απαντήθηκαν από τις Πληροφορίες, 
                        μπορείτε να επικοινωνήσετε με το τηλεφωνικό Κέντρο Εξυπηρέτησης της δράσης <br /> (9:00-17:00) 
                        ή να αποστείλετε email εδώ:&nbsp;
                <br />
                  Για ωφελούμενους: στο <a href="tel:2131513753">2131513753</a> ή στο <br /> <a href="tel:2131513101">2131513101</a> και με mail στο <br />
                <a href=" allazothermansi.thermosifona@prv.ypeka.gr">
                   allazothermansi.thermosifona@prv.ypeka.gr
                </a>{' '}
                <br />
                Για προμηθευτές: στο <a href="tel:2131513075">2131513075</a> ή στο <br /> <a href="tel:2131513355">2131513355</a> και με mail στο <br />
                <a href=" allazothermansi.thermosifona.suppliers@prv.ypeka.gr">
                   allazothermansi.thermosifona.suppliers@prv.ypeka.gr
                </a>{' '}
              </p>
            </div>
          </div>
        )}
      </div>
    </Header>
  );
};

export default HeaderLanding;
